/* Package JSON Import will be here */
import React, { Fragment } from "react";
import { Header, Segment, Button, Icon, Form, Table, Checkbox, Modal, TextArea, Input } from 'semantic-ui-react';
/* Package JSON Import will be here */

/* Project Import will be here */
import * as utils from '../../../services/utility/index';
import { Constants } from "../../../config/appConstants";
import AttachmentViewer from "../../sharedComponent/attachmentViewer/attachmentViewer.Container";
import Loader from "../../sharedComponent/loader/loader";
import SelectTMVoucherModal from "../TMVoucher/TMVoucherComponents/SelectTMVoucherModal";
import PunchesModal from "../TimeCardCommons/PunchesModal";
import { RenderAttestation } from "../Attestation/RenderAttestation";
import { TimeCardWeekStatus } from "../TimeCardCommons/TimeCardStatus";
/* Project Import will be here */

const PreviousWeekTimeCardComponent = props => {
    let count = 0;
    const timeRecordStatus = [Constants.PROCESSED_STATUS, Constants.NEW_STATUS].map(a => a.toLowerCase());

    return (
        <Segment.Group>
            <Fragment>
                <Segment className="stickyHeader">
                    <Header as="h3" size='medium' textAlign='center'> Previous Week Timecard</Header>
                    <Header as="h2" size='tiny' className='layoutStyle d-flex align-items justify-content-between'>
                        <Button primary className="borderRadius  whiteSpace datePickerCursor" size='small' >
                            {`From: ${utils.getMMDDYYYYDateTime(props.timeCard.weekStartDate)} To: ${utils.getMMDDYYYYDateTime(props.timeCard.weekEndingDate)}`}  </Button>
                        <div className='d-flex align-items justify-content-between'>
                            {/* need to common the button */}
                            <Button style={{ opacity: props.timeCard.tmTaskCodeList.length > 0 ? 1 : 0.6, marginRight: '10px' }} secondary className="borderRadius borderColor whiteSpace" fluid size='small' onClick={() => props.timeCard.tmTaskCodeList.length > 0 && props.onClickTMVoucherBtn()}>
                                {Constants.TM_VOUCHER_BUTTON_TEXT} </Button>
                            <Button style={{ marginRight: '10px' }} secondary className="borderRadius borderColor whiteSpace" fluid size='small' onClick={props.getTimeCardIssue}>
                                Issues </Button>
                            <Button secondary className="borderRadius marginRight whiteSpace borderColor" fluid size='small' onClick={() => { props.onClickDailyDetails() }}>
                                Daily Details </Button>
                        </div>
                    </Header>
                </Segment>
                <Segment className="overflowScroll tableScrollData pb-5 ">
                    <Table unstackable className='employeeTime'>
                        <Table.Header className="tableHeaderScroll">
                            <Table.Row textAlign="center">
                                <Table.HeaderCell rowSpan='2'>Date </Table.HeaderCell >
                                <Table.HeaderCell rowSpan='2' className="whiteSpace">Punches</Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2'>Attestation</Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2'>Payroll Note </Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2'>Employee </Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2'>Project </Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2' className="whiteSpace">Task Code </Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2'>Shift </Table.HeaderCell>
                                <Table.HeaderCell className="hoursPadding" colSpan='3'>Hours</Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2'>Actuals </Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2'>Expectations </Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2'>Status </Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2'>Status Code </Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2' className="whiteSpace">Job Override </Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2' className="whiteSpace">Union Override </Table.HeaderCell>
                                <Table.HeaderCell rowSpan='2' className="whiteSpace">Work done <br />at Job Site </Table.HeaderCell>
                            </Table.Row>
                            <Table.Row textAlign="center">
                                <Table.HeaderCell>ST</Table.HeaderCell>
                                <Table.HeaderCell>OT</Table.HeaderCell>
                                <Table.HeaderCell>DT</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        {props.timeCard.timeRecords && props.timeCard.timeRecords.length > 0 && props.timeCard.timeRecords.map((rowData, rowIndex) => {
                            let punches = "";
                            return (
                                <Table.Body>
                                    {
                                        rowData.timecardData && rowData.timecardData.map((data, index) => {
                                            count++;
                                            const currentPunches = `${data.startTime} ${data.lunchStartTime} ${data.lunchEndTime} ${data.endTime} ${data.fullName} (${data.employeeNumber})`;
                                            let samePunches = true;
                                            if (punches !== currentPunches) {
                                                punches = currentPunches;
                                                samePunches = false;
                                            }
                                            return (
                                                <Fragment>
                                                    <Table.Row className={(count % 2 === 0) ? 'dateIndexEven' : 'dateIndexOdd'}>
                                                        <Table.Cell className="fontRoboto">{utils.getMMDDYYYYDateTimeFromUTC(data.createdDate)}</Table.Cell>
                                                        {samePunches ?
                                                            <Table.Cell></Table.Cell>
                                                            :
                                                            <Table.Cell>
                                                                <div className="startLunchTimeWraping" onClick={() => props.openOrClosePunchesModal({ isShowPunchesModal: true, rowIndex, empIndex: index, selectedTimeCardPunches: data })}>
                                                                    <span>{data.startTime}</span>
                                                                    <span>{data.lunchStartTime}</span>
                                                                    <span>{data.lunchEndTime}</span>
                                                                    <span>{data.endTime}</span>
                                                                </div>
                                                            </Table.Cell>
                                                        }
                                                        <RenderAttestation isAllowAttestation={props.timeCard.isAllowAttestation} openAttestationModal={() => props.openAttestation(data.timeRecordID, data.intStatus)} attestationStatus={data.attestationStatus} timeCardStatus={data.intStatus} isFromTimeCard={false} />
                                                        <Table.Cell>
                                                            {index === 0 ?
                                                                <div className="d-flex justify-content-center" onClick={() => {
                                                                    props.openOrClosePayrollNoteModel({ modalOpenPayRollNote: true, rowIndex, empIndex: index });
                                                                }}>
                                                                    <div className={data.payrollNote != null ? "fileEditOutlineHighlighted" : "fileEditOutline"}>
                                                                        <span className="iconify fSize-22" data-icon="mdi-file-edit-outline" data-inline="false" ></span>
                                                                    </div>
                                                                </div>
                                                                : ''}
                                                        </Table.Cell>
                                                        <Table.Cell className='whiteSpace text-left'><b>{index === 0 && data && data.fullName ? `${data.fullName} (${data.employeeNumber})` : ''}</b></Table.Cell>
                                                        <Table.Cell>{data.projectNumber}</Table.Cell>
                                                        <Table.Cell>{data.taskNumber}</Table.Cell>
                                                        <Table.Cell>{data.shift}</Table.Cell>
                                                        <Table.Cell>{data.stHours ? data.stHours : 0}</Table.Cell>
                                                        <Table.Cell>{data.otHours ? data.otHours : 0}</Table.Cell>
                                                        <Table.Cell>{data.dtHours ? data.dtHours : 0}</Table.Cell>
                                                        <Table.Cell>
                                                            {<div className="d-flex justify-content-center" onClick={() => {
                                                                props.openNotes({ modalOpenActualNote: true, rowIndex, empIndex: index });
                                                            }}>
                                                                <div className={data.workNote !== null || data.workUnits !== null || data.isAttachmentAdded ? "fileEditOutlineHighlighted" : "fileEditOutline"} >
                                                                    <span className="iconify fSize-22" data-icon="mdi-file-edit-outline" data-inline="false" ></span>
                                                                </div>
                                                            </div>
                                                            }
                                                        </Table.Cell>
                                                        <Table.Cell>
                                                            {<div className="d-flex justify-content-center" onClick={() => {
                                                                props.openOrCloseExpectationNoteModel({ modalOpenExceptationalNote: true, rowIndex, empIndex: index });
                                                            }}>
                                                                <div className={data.expectationNote !== null || data.expectationUnits > 0 ? "fileEditOutlineHighlighted" : "fileEditOutline"} >
                                                                    <span className="iconify fSize-22" data-icon="mdi-file-edit-outline" data-inline="false" ></span>
                                                                </div>
                                                            </div>
                                                            }
                                                        </Table.Cell>
                                                        <Table.Cell className="text-center">
                                                            {TimeCardWeekStatus(data.intStatus)}
                                                        </Table.Cell>
                                                        <Table.Cell><div className="statusCdeLabel"> {data.fieldStatusDescription ? `${data.fieldStatusInitial}-${data.fieldStatusDescription}` : ""}</div></Table.Cell>
                                                        <Table.Cell>{data.jobOverride}</Table.Cell>
                                                        <Table.Cell>{data.unionOverride}</Table.Cell>
                                                        <Table.Cell>{
                                                            <Checkbox
                                                                name="checkbox"
                                                                checked={(data.workDoneAtJobSite == 'true' || data.workDoneAtJobSite == 'Yes')}
                                                                disabled={true}
                                                            />}
                                                        </Table.Cell>

                                                    </Table.Row>
                                                </Fragment>
                                            )
                                        })}
                                    {
                                        <Table.Row className="totalHoursRows">
                                            <Table.Cell colSpan='7'></Table.Cell>
                                            <Table.Cell>Total</Table.Cell>
                                            <Table.Cell><b>{utils.getFormatedTotalHours(rowData.totalStHours)}</b></Table.Cell>
                                            <Table.Cell><b>{utils.getFormatedTotalHours(rowData.totalOtHours)}</b></Table.Cell>
                                            <Table.Cell><b>{utils.getFormatedTotalHours(rowData.totalDtHours)}</b></Table.Cell>
                                            <Table.Cell colSpan='7'></Table.Cell>
                                        </Table.Row>
                                    }
                                </Table.Body>
                            )
                        })}
                    </Table>
                </Segment>

                <Segment>
                    <div className='d-flex justify-content-center align-items btnFooter'>
                        <Button secondary className="borderRadius w-10" size='small' onClick={props.onClickBack}>
                            Back  </Button>
                    </div>
                </Segment>

                {/* Issue Note Popup */}
                <Modal
                    open={props.timeCard.isIssueNotesModalVisible}
                    closeOnDimmerClick={false}
                    size='tiny'>
                    <Modal.Header className="text-center">Issue Notes</Modal.Header>
                    {props.timeCard.issueNotesList.length > 0 ?
                        <Modal.Content scrolling style={{ minHeight: "auto" }}>
                            <Form className="d-flex flexDirectionColumnReverse">
                                {props.timeCard.issueNotesList && props.timeCard.issueNotesList.map((issue) => (
                                    <div className="boldTextdisabled">
                                        <Form.Group inline>
                                            <label className="textTransformLower">Project</label>
                                            <Input className="w-100" fluid value={issue.projectNumber} disabled={true} />
                                        </Form.Group>
                                        <Form.Group inline>
                                            <label className='textAreaNoteLabel textTransformLower'>Notes</label>
                                            <TextArea className="minHeightTextArea" fluid selection rows='2' value={issue.issueNote} disabled={true} />
                                        </Form.Group>
                                        <Form.Group inline style={{ position: 'relative', marginTop: '2rem', alignItems: 'stretch' }}>
                                            <label className='textTransformstatus'>Status Code</label>
                                            <TextArea className="disableTextArea" fluid value={issue.fieldStatusId ? `${issue.fieldStatusInitial}-${issue.fieldStatusDescription}` : ""} disabled={true} />
                                            <label className="textTransformLower_1">Lost Hours</label>
                                            <Input style={{ width: '25%', marginLeft: '1rem' }} fluid value={issue.lostHours} disabled={true} />
                                        </Form.Group>
                                        <Form.Group widths='equal'>
                                            <Form.Field>
                                                <label className="attachIssue">Attachments</label>
                                                <div className='d-flex justify-content-between'>
                                                    <div className="upload__image-wrapper">
                                                        <div className="attachmentImage">
                                                            {issue.attachments && issue.attachments.map((image, index) => (
                                                                <div key={index} >
                                                                    <img src={Constants.DATA_BASE64 + image.attachmentContent} className='modalSubImage modalSubImage_margin' alt="" onClick={() => props.openAttachmentViewer(image)} />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Form.Field>
                                        </Form.Group>
                                    </div>
                                ))}
                            </Form>
                        </Modal.Content> :
                        <Modal.Content scrolling style={{ minHeight: "auto", textAlign: 'center' }}>
                            No Issue Notes Found
                        </Modal.Content>
                    }

                    <Modal.Actions >
                        <Button secondary className="borderRadius w-25 mr-0" size='small' onClick={props.closeIssueNotes}>
                            Back </Button>
                    </Modal.Actions>
                    {props.timeCard.isShowLoader &&
                        <Loader />
                    }
                </Modal>
                {/* Actual Work Note Popup */}
                <Modal
                    open={props.timeCard.isOpenActualNotes}
                    closeOnDimmerClick={false}
                    size='tiny'
                >
                    <Modal.Header className="text-center">Actuals</Modal.Header>
                    <Modal.Content scrolling style={{ minHeight: "auto" }}>
                        <Form>
                            <Form.Group className='mb-2 boldTextdisabled'>
                                <Form.Input className='modalInput unitInput actualField' label='Actual Units' placeholder='Actual Units' width={6} value={props.timeCard.selectedActualNote.actualUnits} disabled={true} />
                                <Form.Input className='modalInput actualField' control={TextArea} rows="1" label='Actual Work Notes' placeholder='Actual Work Notes' width={10} value={props.timeCard.selectedActualNote.actualNote} disabled={true} />
                            </Form.Group>
                            <Form.Group widths='equal'>
                                <Form.Field>
                                    <label>Attachments</label>
                                    <div className='d-flex justify-content-between'>
                                        <div className="upload__image-wrapper">
                                            <div className="attachmentImage">
                                                {props.timeCard.selectedActualNote && props.timeCard.selectedActualNote.attachments && props.timeCard.selectedActualNote.attachments.map((image, index) => (
                                                    <div key={index} >
                                                        <img src={Constants.DATA_BASE64 + image.attachmentContent} className='modalSubImage modalSubImage_margin' alt="" onClick={() => props.openAttachmentViewer(image)} />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </Form.Field>
                            </Form.Group>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button secondary className="borderRadius w-25 mr-0" size='small' onClick={props.onClickActualNoteBack}>
                            Back </Button>
                    </Modal.Actions>
                    {props.timeCard.isShowLoader &&
                        <Loader />
                    }
                </Modal>

                {/* Payroll Note Popup */}
                <Modal
                    open={props.timeCard.isShowPayrollNoteModal}
                    closeOnDimmerClick={false}
                    size='tiny'
                >
                    <Modal.Header className="text-center">Payroll Note</Modal.Header>
                    <Modal.Content scrolling style={{ minHeight: "auto" }}>
                        <Form>
                            <Form.Group inline className="boldTextdisabled">
                                <TextArea className="minHeightTextArea maxHeightTextArea" placeholder="Notes" fluid selection value={props.timeCard.selectedPayrollNote ? props.timeCard.selectedPayrollNote : ''} disabled={true} />
                            </Form.Group>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions className="d-flex justify-content-center">
                        <Button secondary className="borderRadius w-25 ml-0" size='small' onClick={() => props.openOrClosePayrollNoteModel({ modalOpenPayRollNote: false })}>
                            Back
                        </Button>
                    </Modal.Actions>
                    {props.timeCard.isShowLoader &&
                        <Loader />
                    }
                </Modal>

                {/* Expectation Note Popup */}
                <Modal
                    open={props.timeCard.isShowExpectationNoteModal}
                    closeOnDimmerClick={false}
                    size='tiny'
                >
                    <Modal.Header className="text-center">Expectations</Modal.Header>
                    <Modal.Content className="overflowVisible" scrolling style={{ minHeight: "auto" }}>
                        <Form>
                            <Form.Group className='mb-2 boldTextdisabled'>
                                <Form.Input className='modalInput unitInput' label='Units' placeholder='Units' width={6} value={props.timeCard.selectedExpectationNote ? (props.timeCard.selectedExpectationNote.expectationUnits !== 0 ? props.timeCard.selectedExpectationNote.expectationUnits : '') : ''} disabled={true} />
                                <Form.Input className='modalInput' control={TextArea} rows="1" label='Notes' placeholder='Notes' width={10} value={props.timeCard.selectedExpectationNote ? props.timeCard.selectedExpectationNote.expectationNote : ''} disabled={true} />
                            </Form.Group>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions className="d-flex justify-content-center">
                        <Button secondary className="borderRadius w-25 ml-0" size='small' onClick={() => props.openOrCloseExpectationNoteModel({ modalOpenExceptationalNote: false })}>
                            Back
                        </Button>
                    </Modal.Actions>
                    {props.timeCard.isShowLoader &&
                        <Loader />
                    }
                </Modal>

                {/* Start Time Lunch Time */}
                <PunchesModal
                    isShowPunchesModal={props.timeCard.isShowPunchesModal}
                    selectedTimeCardPunches={props.timeCard.selectedTimeCardPunches}
                    isShowLoader={props.timeCard.isShowLoader}
                    openOrClosePunchesModal={props.openOrClosePunchesModal}
                />
            </Fragment>
            {/* Select Task Code Popup */}
            {props.timeCard.isShowTMVoucher &&
                <SelectTMVoucherModal
                    tmVoucherHeaderTwo={Constants.TM_VOUCHER_POPUP_HEADING_VIEW_DATA}
                    isShowTMVoucher={props.timeCard.isShowTMVoucher}
                    selectedTMVoucher={props.timeCard.selectedTMVoucher}
                    tmTaskCodeList={props.timeCard.tmTaskCodeList}
                    onChangeSelectTaskCode={props.onChangeSelectTaskCode}
                    onClickTMVoucherBackBtn={props.onClickTMVoucherBackBtn}
                    onClickSelectBtn={props.onClickSelectBtn}
                    isShowDate={true}
                />
            }
            {
                props.timeCard.isAttachmentModelVisible &&
                <AttachmentViewer attachmentName={props.timeCard.selectedAttachment.attachmentName} attachmentContent={props.timeCard.selectedAttachment.attachmentContent} closeAttachmentViewer={props.closeAttachmentViewer} />
            }
            {props.timeCard.isShowLoader &&
                <Loader />
            }
        </Segment.Group>

    );
}

export default PreviousWeekTimeCardComponent;

PreviousWeekTimeCardComponent.displayName = "PreviousWeekTimeCardComponent";